import React from "react";
import { useTheme } from "styled-components";
import { Flex } from "../Flex";
import { Text } from "../Text";
export const EmptyChart = ({ emptyMessage, emptyMessageFontSize }) => {
    const { colors: { chartColors }, } = useTheme();
    return (React.createElement(Flex, { sx: {
            alignItems: "center",
            height: "100%",
            justifyContent: "center",
            width: "100%",
        } },
        React.createElement(Text, { fontSize: emptyMessageFontSize || "16px", fontWeight: "normal", color: chartColors.emptyChartText, "data-testid": "EmptyChartText" }, emptyMessage)));
};
